import React, { useState } from 'react'
import { Modal, Form, Radio, DatePicker, App, Button } from 'antd'
import { useDingdanshouruYHZHMutation, useDingdanzhichuYHZHMutation, useFeiyongYHZHMutation, useJiekuanYHZHMutation } from '../store/DianShangYeWuApi';
function BankRecordAdd(props) {
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const [info, setInfo] = useState({});
    const [open, setOpen] = useState(false);
    const [dingdanshouruYHZH] = useDingdanshouruYHZHMutation();
    const [dingdanzhichuYHZH] = useDingdanzhichuYHZHMutation();
    const [feiyongYHZH] = useFeiyongYHZHMutation();
    const [jiekuanYHZH] = useJiekuanYHZHMutation();    
    return (
        <>
            <Button 
                type='primary' 
                onClick={() => {
                setOpen(true);
            }}>批量记账</Button>
            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                onOk={() => {
                    if(!info.qyyhzh_id || !info.date){
                        message.error('请选择银行账户和日期');
                        return;
                    }
                    if(!props.selectedRowAmount.reduce((acc, curr) => acc + Number(curr || 0), 0) || props.selectedRowAmount.reduce((acc, curr) => acc + Number(curr || 0), 0) === 'undefined'){
                        message.error('请输入转账金额');
                        return;
                    }
                    if(props.selectedRowTypeNames.length !== props.selectedRowId.length){
                        message.error('请选择相同类型的单据');
                        return;
                    }
                    if(props.selectedRowZFLXs.length !== props.selectedRowId.length){
                        message.error('请选择相同类型的单据');
                        return;
                    }
                    if(props.selectedRowAmount.length !== props.selectedRowId.length){
                        message.error('请选择相同类型的单据');
                        return;
                    }
                    if(props.selectedRowTypeNames[0] === '收款单'){
                        dingdanshouruYHZH({
                            'ddsr_id': props.selectedRowId,
                            'ddsr_qyyhzh_id': info.qyyhzh_id,
                            'ddsr_qyyhzh_name': info.qyyhzh_name,
                            'ddsr_qyyhzh_amount': props.selectedRowAmount,
                            'ddsr_qyyhzh_zflx': props.selectedRowZFLXs,
                            'ddsr_qyyhzh_date': info.date,
                            'ddsr_qyyhzh_uid': props.yh_id,
                            'ddsr_qyyhzh_uname': props.yh_name
                        }).then(res => {
                                if(res.data.Status === 'success'){
                                    message.success('新增成功');
                                    setOpen(false);
                                    props.refetch();
                                    props.onSuccess?.();
                                }else if(res.data.Status === 'fail')    {
                                    message.error('新增失败'+res.data.Message);
                                }
                            });
                    }else if(props.selectedRowTypeNames[0] === '付款单'){
                        dingdanzhichuYHZH({
                            'ddzc_id': props.selectedRowId,
                            'ddzc_qyyhzh_id': info.qyyhzh_id,
                            'ddzc_qyyhzh_name': info.qyyhzh_name,
                            'ddzc_qyyhzh_amount': props.selectedRowAmount.reduce((acc, curr) => acc + Number(curr || 0), 0),
                            'ddzc_qyyhzh_zflx': props.selectedRowZFLXs,
                            'ddzc_qyyhzh_date': info.date,
                            'ddzc_qyyhzh_uid': props.yh_id,
                            'ddzc_qyyhzh_uname': props.yh_name
                        }).then(res => {
                            if(res.data.Status === 'success'){
                                message.success('新增成功');
                                setOpen(false);
                                props.refetch();
                                props.onSuccess?.();
                            }else if(res.data.Status === 'fail')    {
                                message.error('新增失败'+res.data.Message);
                            }
                        });
                    }else if(props.selectedRowTypeNames[0] === '费用单'){
                        feiyongYHZH({
                            'fy_id': props.selectedRowId,
                            'fy_qyyhzh_id': info.qyyhzh_id,
                            'fy_qyyhzh_name': info.qyyhzh_name,
                            'fy_qyyhzh_amount': props.selectedRowAmount.reduce((acc, curr) => acc + Number(curr || 0), 0),
                            'fy_qyyhzh_zflx': props.selectedRowZFLXs,
                            'fy_qyyhzh_date': info.date,
                            'fy_qyyhzh_uid': props.yh_id,
                            'fy_qyyhzh_uname': props.yh_name
                        }).then(res => {
                            if(res.data.Status === 'success'){
                                message.success('新增成功');
                                setOpen(false);
                                props.refetch();
                                props.onSuccess?.();
                            }else if(res.data.Status === 'fail')    {
                                message.error('新增失败'+res.data.Message);
                            }
                        });
                    }else if(props.selectedRowTypeNames[0] === '借款单'){
                        jiekuanYHZH({
                            'jk_id': props.selectedRowId,
                            'jk_qyyhzh_id': info.qyyhzh_id,
                            'jk_qyyhzh_name': info.qyyhzh_name,
                            'jk_qyyhzh_amount': props.selectedRowAmount.reduce((acc, curr) => acc + Number(curr || 0), 0),
                            'jk_qyyhzh_zflx': props.selectedRowZFLXs,
                            'jk_qyyhzh_date': info.date,
                            'jk_qyyhzh_uid': props.yh_id,
                            'jk_qyyhzh_uname': props.yh_name
                        }).then(res => {
                            if(res.data.Status === 'success'){
                                message.success('新增成功');
                                setOpen(false);
                                props.refetch();
                                props.onSuccess?.();
                            }else if(res.data.Status === 'fail')    {
                                message.error('新增失败'+res.data.Message);
                            }
                        });
                    }
                }}
                title='新增银行转账记录'
                width={800}
            
            >
                <Form 
                    form={form} 
                    labelCol={{ span: 5 }}
                    name={'form_bank_record_add'+props.selectedRowId.join('_')}                   
                >
                    <Form.Item label='单据类型'>{props.selectedRowTypeNames[0]}</Form.Item>
                    <Form.Item label={props.selectedRowTypeNames[0] === '收款单' ? '转入金额' : '转出金额'}>
                        <span style={{color: props.selectedRowTypeNames[0] === '收款单' ? 'red' : 'green',fontWeight: 'bold',fontSize: '16px'}}>
                            ￥{props.selectedRowAmount.reduce((acc, curr) => acc + Number(curr || 0), 0).toLocaleString('zh-CN', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}
                        </span>
                    </Form.Item>
                    <Form.Item name='qyyhzh_id' label='银行账户' rules={[{ required: true, message: '请输入银行账户' }]}>
                        <Radio.Group 
                            options={props.bankAccountList.map(item => ({ label: item.qyyhzh_name, value: item.qyyhzh_id }))} 
                            onChange={(e) => {
                                setInfo(prev => ({
                                    ...prev, 
                                    qyyhzh_id: e.target.value, 
                                    qyyhzh_name: props.bankAccountList.find(item => item.qyyhzh_id === e.target.value).qyyhzh_name
                                }));
                            }} 
                        />
                        
                    </Form.Item>
                    
                    <Form.Item name='ddsr_amount' label='转账日期' rules={[{ required: true, message: '请输入日期' }]}>
                        <DatePicker onChange={(e) => {
                            setInfo(prev => ({...prev, date: e.format('YYYY-MM-DD')}));
                        }} />
                    </Form.Item>
                </Form>
            </Modal>

        </>
    )
}

export default BankRecordAdd